import React, { Fragment, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MemoryRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import '../../styles/global.scss';
import { GlobalStyleV2 } from '../../styles/global-v2';
import { env } from '../../utils';
import { rgIDs } from '../../../shared/constants/domIDs';
import { Router } from './components/router';
import { BrandingProvider } from '../../context/BrandingContext';

const domNode = document.getElementById(rgIDs.messengerV2);

const DebugMode = env.isDevelopment ? StrictMode : Fragment;
const queryClient = new QueryClient();

if (domNode) {
  const root = createRoot(domNode);

  root.render(
    <DebugMode>
      <BrandingProvider>
        <QueryClientProvider client={queryClient}>
          <MemoryRouter initialEntries={['/']}>
            <Router />
          </MemoryRouter>
        </QueryClientProvider>
        <GlobalStyleV2 />
      </BrandingProvider>
    </DebugMode>
  );
}
